import React from "react";
import LanguageSelectionDropDown from "../Components/LanguageDropDown";
import {  SupplierLogoContainer } from "../Components/MainApp";
import PaymentMethodsUX from "./PaymentMethodsUX";
import PaymentSummaryUX from "./PaymentSummaryUX";
import { StaticFooter } from "../Components/Common";

const ModernUX = (props) => {
  return (
    <div>
      <SupplierLogoContainer history={props.history} />
      <LanguageSelectionDropDown />

      <div className="container-main">
        <PaymentMethodsUX />
        <PaymentSummaryUX/>
      </div>
      <StaticFooter parent="static-invoice-footer" />
    </div>
  );
};

export default ModernUX;
